import { render, staticRenderFns } from "./SidebarItemComponent.vue?vue&type=template&id=343dc106&scoped=true&"
import script from "./SidebarItemComponent.vue?vue&type=script&lang=js&"
export * from "./SidebarItemComponent.vue?vue&type=script&lang=js&"
import style0 from "./SidebarItemComponent.vue?vue&type=style&index=0&id=343dc106&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343dc106",
  null
  
)

export default component.exports